// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"108":"6176d44e","347":"0c0054c1","453":"a4631182","507":"2f8e14d6","565":"2dd846b7","974":"d3e9c4b6"}[chunkId] + ".chunk.js";
};